import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { store } from "@components/VerticalLayout/store";
import { generalConfigStore, setItemsDisable } from "@store";
import {
    store as saleStore,
    setNumberActive,
    setIsArchived,
    setEditedDataModeOfSale,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsLoading,
} from "../store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import {
    CustomCardBody,
    CustomCardHeader,
} from "@components/Common/CustomCardStyled";
import { languages } from "@constants/index";
import {
    associateModeOfSale,
    checkDeliverooAvailability,
    checkIfModeOfSaleExist,
    FetchPost,
    getSaleSupportUsed,
    initialState,
    MODE_OF_SALE_LABEL,
    ModeOfSaleFormType,
} from "./modeOfSaleCheckers";
import {
    DisplayNameInput,
    FormFooter,
    FormHeader,
    SalesModeSelect,
    SalesSupportSelect,
    TagsInput,
} from "./SalesMethodFormComponents";
import ModalsContainer from "./ModalsContainer";
import {
    buildCommonPayload,
    formatCreateLabel,
    getModeOfSaleStatus,
    initializeSalesData,
    prepareEditData,
    resetAfterModeOfSaleUpdate,
    resetFormState,
} from "./hooks";
import ErrorToast from "@components/Common/ErrorTost";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { checkRequiredFields, isFormUnchanged, isFormValid } from "./helper";
import { useFetchGlobal } from "../../../../api/hooks";

export default function SaleForm({
    setDataIsUpdated,
    dataSale,
    setDataSale,
    setLocalFilterActive,
    inputSaleMode,
    setInputSaleMode,
    selectSales,
    setSelectSales,
    selectName,
    setSelectName,
    setLimit,
    setIsConsult,
    isConsult,
    dataState,
    SalesModesTypesAndTag,
    formState,
    setFormState,
    setSalesSupport,
    salesSupport,
    setTagsData,
    tagsData,
    setModalState,
    modalState,
    isLoading,
}: ModeOfSaleFormType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { userID, franchiseID, shopID, oneShop, operatorID } = useSnapshot(
        store
    );
    const {
        numberActive,
        shopsModeSaleData,
        modeSaleData,
        modeOfSaleFranchise,
        dataArchive,
        dataFranchiseArchive,
        isActionsClicked,
        isEdited,
    } = useSnapshot(saleStore);
    const { itemsDisable } = useSnapshot(generalConfigStore);

    const shopId = oneShop ? shopID : 0;
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isModalModifiedOpened, setIsModalModifiedOpened] = React.useState<
        boolean
    >(false);
    const [
        isAdvancedDisplayNameModalOpen,
        setIsAdvancedDisplayNameModalOpen,
    ] = React.useState(false);
    const [isNameExist, setIsNameExist] = React.useState<boolean>(false);
    const [associated, setAssociated] = React.useState<any[]>([]);

    const [state, setState] = React.useState(initialState);
    const [
        isValidateButtonDisabled,
        setIsValidateButtonDisabled,
    ] = React.useState<boolean>(false);

    const [
        isModeOfSaleActiveInTemplate,
        setIsModeOfSaleActiveInTemplate,
    ] = React.useState(false);

    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    const selectedLanguage: any = languages.find(
        (el: any) => el.value === i18nextLng
    );
    async function addModeOfSale() {
        if (isValidateButtonDisabled) return;
        setIsLoading(true);
        setIsValidateButtonDisabled(true);
        const {
            id,
            isFranchiseEmpty,
            isShopEmpty,
            isModeOfSaleFranchiseExist,
            isModeOfSaleFranchiseExistAndArchived,
        } = getModeOfSaleStatus({
            formState,
            salesMode: state.salesMode,
            oneShop,
            modeOfSaleFranchise,
            modeSaleData,
            dataFranchiseArchive,
        });
        if (oneShop && !isShopEmpty) {
            const itemDisable = [
                ...JSON.parse(JSON.stringify(itemsDisable)),
                { id, state: false, shopId },
            ];
            setItemsDisable(itemDisable);
            localStorage.setItem("itemsDisable", JSON.stringify(itemDisable));
        }
        const dataToSend = buildCommonPayload(
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            state.tags,
            id,
            formState,
            salesSupport,
            isShopEmpty,
            isFranchiseEmpty,
            oneShop,
            shopId,
            tagsData,
            isModeOfSaleFranchiseExist
        );
        if (isModeOfSaleFranchiseExist && oneShop) {
            setIsLoading(false);
            setIsModalModifiedOpened(true);
            setIsArchived(false);
            setIsValidateButtonDisabled(false);
            return;
        }
        if (isModeOfSaleFranchiseExistAndArchived && oneShop) {
            setIsLoading(false);
            setIsModalModifiedOpened(true);
            setIsArchived(true);
            setIsValidateButtonDisabled(false);
            return;
        }
        try {
            const result: any = await FetchPost(dataToSend, fetchGlobal);
            if (result.error) throw new Error("API error");
            resetFormState({
                setSalesSupport,
                setIsLoading,
                setDataSale,
                setIsEdited,
                setLocalFilterActive,
                setNumberActive,
                numberActive,
                setState,
                tagsData,
                setTagsData,
                setFormState,
                setIsValidateButtonDisabled,
                setDataIsUpdated,
            });
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
            setIsLoading(false);
            setIsValidateButtonDisabled(false);
        }
    }

    async function editModeOfSale() {
        setIsLoading(true);
        let dataAssociate: any[] = [];
        toast.dismiss();
        if (!oneShop) {
            dataAssociate = associateModeOfSale(dataSale, shopsModeSaleData);
            setIsLoading(false);
        }
        if (isValidateButtonDisabled === false) {
            setIsValidateButtonDisabled(true);
            const result = prepareEditData(
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                state.tags,
                formState,
                salesSupport,
                shopId,
                tagsData,
                dataSale,
                dataState
            );
            setEditedDataModeOfSale(result.dataConfig[0]);
            if (dataAssociate.length > 0) {
                setIsModalOpen(true);
                setIsLoading(false);
                setIsValidateButtonDisabled(false);
            } else {
                try {
                    let response: any = await FetchPost(
                        {
                            dataConfig: result.dataConfig,
                            updatedData: result.updatedData,
                        },
                        fetchGlobal
                    );

                    if (response.error) {
                        throw Error("error");
                    }
                    resetAfterModeOfSaleUpdate({
                        setState,
                        tagsData,
                        setIsLoading,
                        setIsEdited,
                        setTagsData,
                        setModalState,
                        setDataIsUpdated,
                        setIsValidateButtonDisabled,
                        setSalesSupport,
                    });
                } catch (e) {
                    setIsLoading(false);
                    ErrorToast(`${t("There's an error")!}`);
                }
            }
        }
    }

    function handleValidateButtonOnClickEvent() {
        checkRequiredFields(
            formState,
            salesSupport,
            i18nextLng,
            setInputSaleMode,
            setSelectSales,
            setSelectName
        );

        const isEdit = Boolean(dataSale.Id);

        if (isEdit) {
            if (isFormUnchanged(formState, dataSale, tagsData, salesSupport)) {
                setIsModalOpened(!isModalOpened);
            } else if (
                isFormValid(formState, salesSupport, isNameExist, i18nextLng)
            ) {
                editModeOfSale();
            }
        } else {
            if (isFormValid(formState, salesSupport, isNameExist, i18nextLng)) {
                addModeOfSale();
            }
        }
    }
    function updateSalesSupportData(saleMode: string) {
        let isDeliverooUsed = false;
        let isSaleModeEditable = false;
        const combinedSalesData = [
            ...modeSaleData.data,
            ...modeSaleData.othersData.dataArchive,
        ];
        isDeliverooUsed = combinedSalesData.some((entry) =>
            entry.support_vente.includes("Deliveroo")
        );
        if (dataSale.Id !== undefined) {
            isSaleModeEditable =
                !salesSupport.includes("Deliveroo") &&
                dataSale.support_vente.includes("Deliveroo");
        }
        const saleSupportList = SalesModesTypesAndTag.ListSaleSupport;

        if (saleMode !== "") {
            if (
                (!isDeliverooUsed || isSaleModeEditable) &&
                [t("Takeaway"), t("In delivery")].includes(saleMode)
            ) {
                setState((prev) => ({
                    ...prev,
                    salesSupportData: saleSupportList,
                }));
            } else {
                const filteredData = saleSupportList.filter(
                    (element: string) => element !== "Deliveroo"
                );
                setState((prev) => ({
                    ...prev,
                    salesSupportData: filteredData,
                }));
            }
        }
    }

    const isDeliverooAvaible = checkDeliverooAvailability({
        oneShop,
        modeSaleData,
        modeOfSaleFranchise,
        formState,
    });

    useEffect(() => {
        let isModeOfSaleExist = checkIfModeOfSaleExist(
            formState,
            modeSaleData,
            dataArchive
        );
        if (
            isModeOfSaleExist &&
            (dataSale.Id === undefined ||
                (dataSale.Id !== undefined &&
                    dataSale[MODE_OF_SALE_LABEL] !== formState.saleMode))
        ) {
            setIsNameExist(true);
        } else {
            setIsNameExist(false);
        }
        // eslint-disable-next-line
    }, [formState.saleMode, dataSale, checkIfModeOfSaleExist]);

    useEffect(() => {
        if (formState.advancedDisplayName.languages[i18nextLng] !== "") {
            setSelectName(false);
        }
        // eslint-disable-next-line
    }, [formState.advancedDisplayName, i18nextLng]);
    React.useEffect(() => {
        if (dataSale.Id !== undefined) {
            getSaleSupportUsed(
                userID,
                shopId,
                franchiseID,
                dataSale.Id,
                setState,
                setIsModeOfSaleActiveInTemplate,
                fetchGlobal
            );
            updateSalesSupportData(dataSale[MODE_OF_SALE_LABEL]);
        }
        // eslint-disable-next-line
    }, [getSaleSupportUsed, dataSale.Id]);

    React.useEffect(() => {
        initializeSalesData(SalesModesTypesAndTag, setState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (dataSale.Id !== undefined) {
            updateSalesSupportData(dataSale[MODE_OF_SALE_LABEL]);
        }
        // eslint-disable-next-line
    }, [salesSupport]);
    useEffect(() => {
        setAssociated(associateModeOfSale(dataSale, shopsModeSaleData));

        // eslint-disable-next-line
    }, [dataSale, t, modalState.isAddNewModeOfSaleButtonClicked]);

    const handleSetAdvancedDisplayName = (newDisplayName: any) => {
        setFormState((prev: any) => ({
            ...prev,
            advancedDisplayName: newDisplayName,
        }));
    };

    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <FormHeader
                        title={formState.title}
                        isEdited={isEdited}
                        setIsConsult={setIsConsult}
                        setIsActionsClicked={setIsActionsClicked}
                        setActions={setActions}
                        setDataSale={setDataSale}
                        setIsEdited={setIsEdited}
                        clearMultiCustomSelectionData={
                            clearMultiCustomSelectionData
                        }
                        clearData={clearData}
                        setInputSaleMode={setInputSaleMode}
                        setDataIsUpdated={setDataIsUpdated}
                        setModalState={setModalState}
                    />
                </CustomCardHeader>
                <CustomCardBody
                    className={`pl-3 pr-5 ${isConsult ? "pe-none__clz" : ""}`}
                    style={{ maxHeight: "470px", overflowY: "auto" }}
                >
                    <SalesModeSelect
                        salesMode={state.salesMode}
                        formState={formState}
                        setFormState={setFormState}
                        inputSaleMode={inputSaleMode}
                        isNameExist={isNameExist}
                        dataSale={dataSale}
                        setIsEdited={setIsEdited}
                        setInputSaleMode={setInputSaleMode}
                        setIsNameExist={setIsNameExist}
                        setSelectName={setSelectName}
                        updateSalesSupportData={updateSalesSupportData}
                    />
                    <DisplayNameInput
                        formState={formState}
                        setFormState={setFormState}
                        setIsEdited={setIsEdited}
                        setSelectName={setSelectName}
                        selectName={selectName}
                        t={t}
                        selectedLanguage={selectedLanguage}
                        i18nextLng={i18nextLng}
                        isAdvancedDisplayNameModalOpen={
                            isAdvancedDisplayNameModalOpen
                        }
                        setIsAdvancedDisplayNameModalOpen={
                            setIsAdvancedDisplayNameModalOpen
                        }
                    />

                    <SalesSupportSelect
                        formState={formState}
                        salesSupport={salesSupport}
                        setSalesSupport={setSalesSupport}
                        salesSupportData={state.salesSupportData}
                        setIsEdited={setIsEdited}
                        setSelectSales={setSelectSales}
                        t={t}
                        selectSales={selectSales}
                        saleSupportUsed={state.saleSupportUsed}
                        isModeOfSaleActiveInTemplate={
                            isModeOfSaleActiveInTemplate
                        }
                        isDeliverooAvaible={isDeliverooAvaible}
                        isNameExist={isNameExist}
                    />
                    <TagsInput
                        tagsData={tagsData}
                        setTagsData={setTagsData}
                        tags={state.tags}
                        t={t}
                        setIsEdited={setIsEdited}
                        formatCreateLabel={formatCreateLabel}
                    />
                </CustomCardBody>
                <FormFooter
                    isEdited={isEdited}
                    isConsult={isConsult}
                    isActionsClicked={isActionsClicked}
                    setIsEdited={setIsEdited}
                    setIsConsult={setIsConsult}
                    setActions={setActions}
                    setModalState={setModalState}
                    setDataSale={setDataSale}
                    setDataIsUpdated={setDataIsUpdated}
                    clearData={clearData}
                    clearMultiCustomSelectionData={
                        clearMultiCustomSelectionData
                    }
                    setIsActionsClicked={setIsActionsClicked}
                    handleValidateButtonOnClickEvent={
                        handleValidateButtonOnClickEvent
                    }
                    setSalesSupport={setSalesSupport}
                />
            </AvForm>
            <ModalsContainer
                setDataIsUpdated={setDataIsUpdated}
                setDataSale={setDataSale}
                setIsEdited={setIsEdited}
                isModalOpen={isModalOpen}
                associated={associated}
                salesSupport={salesSupport}
                dataSale={dataSale}
                setLimit={setLimit}
                isModalModifiedOpened={isModalModifiedOpened}
                formState={formState}
                tagsData={tagsData}
                setTagsData={setTagsData}
                i18nextLng={i18nextLng}
                isConsult={isConsult}
                isAdvancedDisplayNameModalOpen={isAdvancedDisplayNameModalOpen}
                setIsAdvancedDisplayNameModalOpen={
                    setIsAdvancedDisplayNameModalOpen
                }
                handleSetAdvancedDisplayName={handleSetAdvancedDisplayName}
                language={state.language}
                isActionsClicked={isActionsClicked}
                setActions={setActions}
                setIsActionsClicked={setIsActionsClicked}
                setIsModalOpen={setIsModalOpen}
                setIsModalModifiedOpened={setIsModalModifiedOpened}
                setModalState={setModalState}
                modalState={modalState}
                tags={state.tags}
                setSalesSupport={setSalesSupport}
                setState={setState}
            />
        </React.Fragment>
    );
}
